<template>
  <div class="all-question-outer">
      <div class="sign" v-if="questionData.data.content">
          <div class="cancelSign" @click="cancelSign(questionData)" v-if="questionData.form&&questionData.form.is_sign == '1'">
              <img src="../../../../assets/cancelSign.png" alt="">
              <span>取消标记</span>
          </div>
          <div class="addSign" @click="addSign(questionData)" v-else>
              <img src="../../../../assets/addSign.png" alt="">
              <span>标记此题</span>
          </div>
      </div>
      <div class="question" v-if="questionData.data.content">
          <div class="questionTop">
              <div class="title">「判断题」<span class="score" v-if="questionData.data.score">{{questionData.data.score}}分</span></div>
              <!-- 试题附件展示组件 -->
        <question-files
          v-if="questionData.data.attachment"
          :attachment="questionData.data.attachment"
        ></question-files>
              <span class="questionName">{{questionData.data.num}}、<span v-html="questionData.data.content"></span></span>
          </div>
          <ul>
            <a-radio-group v-model="value" @change="onChange(questionData)">
                <a-radio :style="radioStyle" value="1">
                    正确
                </a-radio>
                <a-radio :style="radioStyle" value="2">
                    错误
                </a-radio>
            </a-radio-group>
          </ul>
      </div>
      <div class="question" v-else>
          <div class="questionTop">
              <span class="deleted">{{questionData.data.num}}、此题已被删除</span>
          </div>
          <div class="deleteImg">
              <img src="@/assets/deleted.png" alt="">
          </div>
      </div>
  </div>
</template>

<script>
import QuestionFiles from "../questionFiles.vue";
export default {
    name:"judge",
     components: { QuestionFiles },
    props:['questionData'],
    data(){
        return{
            value: this.questionData.form.answer,
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            },
        }
    },
    created(){
        
    },
    methods:{
        onChange(val) {
            val.form.answer = this.value;
        },
        //取消标记
        cancelSign(val){
            val.form.is_sign = "2";
            this.$forceUpdate()
        },
        //标记此题
        addSign(val){
            val.form.is_sign = "1";
            this.$forceUpdate()
        }
    }

}
</script>

<style lang="less" scoped>
.all-question-outer {
    width: 100%;
    height: calc(100% - 60px);
    padding: 20px 50px 30px 50px;
    position: relative;
}
.sign{
    height: 32px;
    position: absolute;
    top: 35px;
    right: 50px;
}
.sign img{
    width: 30px;
    height: auto;
    margin-right: 4px;
    display: inline-block;
}
.sign span{
    line-height: 32px;
}
.cancelSign{
    float: right;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.cancelSign span{
    width: 57px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #F79E3F;
    line-height: 32px;
}
.addSign{
    float: right;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.addSign span{
    width: 57px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 32px;
}
.questionTop{
    width: 100%;
    padding: 15px 0 0;
    /deep/img {
        display: block;
        max-width: 100%;
    }
    /deep/p:first-child {
        display: inline;
    }
    /deep/ol{
        list-style: decimal;
    }
}
.question .title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 32px;
}
.question .questionName{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #14202C;
    line-height: 32px;
    word-wrap: break-word;
    word-break: normal;
}
/deep/p {
    display: inline;
}
.score{
  color: #9A3BEC;
  font-weight: normal;
}
.deleted{
    color: #EA7E7B;
    font-size: 16px;
}
.deleteImg{
    text-align: center;
    height: 475px;
    margin-top: 140px;
}
</style>